export const ModuleIdMappingQa = {
  PUBLIC_MODULE_ID: 'PUBLIC_MODULE_ID',
  OVERTIME_MODULE_ID: '26ca5a8f-c482-4337-b24b-339979f1e288',
  CREATE_OVERTIME_MODULE_ID: '182d5378-4ed1-41e6-b5b5-482649249dfa',
  EDIT_EMPLOYEE: '90708fa3-3f11-41e0-94fd-6a25213fe29e',
  ELLIGIBLE_EMPLOYEE: 'eabe1c15-2d55-4847-90a3-cf5e6fda11a3',
  ATTENDANCE_LOG: 'fe02be87-7b51-4937-b1a8-288ecfdb0eb1',
  REGULARIZATION: '52f620ba-ab90-48a1-be6a-b40a09593a52',
  BULK_UPLOAD: 'dc056b62-bdfc-4ccf-9e80-7c924aa16481',
  BULK_REGULARIZATION: '0a3b3ae3-f762-48ee-8e55-b68bd8dcf255',
  BULK_USER_UPLOAD: 'd8480e00-eb91-47b3-bf88-a06cc9bb2014',
  BULK_GRACE_ATTENDANCE: '07c83c1f-2481-4885-a4d3-b6198c3edb5b',
  BULK_ROLE_UPDATE: '33d26b6d-60c8-44e1-9246-3486bbe2d58a',
  PUNCH_IN_APPROVALS: 'acb67e8c-62ae-49a1-a3cd-99b29affeaee',
  PUNCH_OUT_APPROVALS: 'd056bc68-8a53-42c1-b8b1-0d164dc7347e',
  OT_TOP_UP: '58e4ddb3-15f6-4200-bba5-4c2a638d6992',
  SPOOF_APPROVAL: 'cf56d181-dec2-46b8-8e7f-9019fd5e80bf',
  PLANNED_OT_APPROVAL: '96962751-b8aa-471d-935b-ab0b367a12c3',
  SITE_MODULE: '604bb225-1cb7-4b90-b31e-ac47f4b15d25',
  SITE_MANAGEMENT: '375ce13a-39e6-4fb7-9e7d-10ae7de01be0',
  SHIFT_MANAGEMENT: 'a1159503-3e01-408e-8a89-b207ab70adef',
  ROSTER_MANAGEMENT: '615b4040-5729-4c2a-8c50-002ef968da7b',
  AREA_MANAGEMENT: 'be318a3c-d406-4331-baab-108babc29a4b',
  LEAVES: 'c0985302-acc5-4d50-9098-2c89190fc6fc',
  HOLIDAY_CONFIGURATIONS: 'c2727476-1ccc-489c-95ec-f3b8e7c2179b',
  LEAVE_CONFIGURATIONS: '188c6728-c8af-405a-8e4a-6f0b1b9afc90',
  SEPARATION: 'ab0f7421-95c6-4cf4-a3d8-78856c1f4ae8',
  SEPARATION_HISTORY_OPEN_REQUESTS: 'ab0f7421-95c6-4cf4-a3d8-78856c1f4ae8',
  SEPARATION_HISTORY_CLOSED_REQUESTS: 'ab0f7421-95c6-4cf4-a3d8-78856c1f4ae8',
  APPROVAL: '4d0410be-9289-4b08-96bc-eec5c162b222',
  APPROVAL_LEAVES: '48eded37-b4dc-4304-a0c2-1fb043bc8915',
  APPROVAL_LEAVES_OPEN_REQUESTS: '48eded37-b4dc-4304-a0c2-1fb043bc8915',
  APPROVAL_LEAVES_CLOSED_REQUESTS: '48eded37-b4dc-4304-a0c2-1fb043bc8915',
  APPROVAL_SEPARATION: 'a1b10b0a-99c7-4434-ba92-75826efef856',
  APPROVAL_SEPARATION_OPEN_REQUESTS: 'a1b10b0a-99c7-4434-ba92-75826efef856',
  APPROVAL_SEPARATION_CLOSED_REQUESTS: 'a1b10b0a-99c7-4434-ba92-75826efef856',
  REPORTS: 'bd2c0ee2-7706-469c-a354-5303647630c0',
  UPLOAD_REPORTS_MODULE: 'bd2c0ee2-7706-469c-a354-5303647630c0',
  DOWNLOAD_REPORTS_MODULE: 'bd2c0ee2-7706-469c-a354-5303647630c0',
  CANDIDATE_MODULE: '007bdf4a-a633-4fa8-ae16-327d59810917',
  JOB_REQUISITION_MODULE: '3a53c1ca-5680-42ef-a607-11abf209d741',
  JOB_REQUISITION_CANDIDATE_MODULE: 'e4d3c8f8-6b47-4cd0-b352-f5de34a5aebc',
  APPLICATION_STATUS_MODULE: '1548c98f-c16b-43e6-b5ff-2290e94ee597',
  CANDIDATE_REVIEW_MODULE: '90ec4151-8c8c-4501-9a16-fc1b8bf6d297',
  CANDIDATE_PRE_ONBOARDING: '4b9833ca-22cc-48d6-abff-f3e05179073a',
  USER_MANAGEMENT: 'be031cd3-1fab-4643-875d-2002cdfda703',
  USERS: '6003e173-e159-408a-9776-4a31706f68df',
  ROLES: '903cbb98-0a84-4c85-9768-519fe7431566',
  CONFIG: 'f5fd80c4-94e8-4659-829e-49628f203ba2',
  SITE_LEVEL_CONFIG: '132cb86a-bf29-4bb1-9b91-a9650c375dcd',
  ROLE_LEVEL_CONFIG: '23ca73b2-4080-4b8a-900e-4fae103c53b8',
  ONBOARDING_TRACKER: '007bdf4a-a633-4fa8-ae16-327d59810917',
  TEAM_MANAGEMENT: '6bcb1190-7bfb-4c4b-9ad6-c7e63d4acfd3',
  VENDORS: '2ac2c833-690d-4ab8-b34e-d69802cad547',
  VENDORS_LIST: '2ac2c833-690d-4ab8-b34e-d69802cad547',
  VENDOR_REPORT: 'e7f5cff0-2197-4b8b-8a12-1dfcf7fa6188',
  APPROVAL_BGV_CLOSED_REQUESTS: '1f0dc42f-689a-4646-8498-a2aac56cfe48',
  APPROVAL_BGV_OPEN_REQUESTS: '1f0dc42f-689a-4646-8498-a2aac56cfe48',
  APPROVAL_BGV: '1f0dc42f-689a-4646-8498-a2aac56cfe48',
  FLEX_MANAGEMENT: '5a871eb1-1c3a-4992-a3c4-2d2ccdd7a038',
  FLEX_SLOT_MANAGEMENT: '996b96d0-ad16-4f5a-841d-e3f2c9ab56d0',
  FLEX_RATE_CARD_MANAGEMENT: '07200602-8b23-4ecf-90a7-9df9ffa306c1',
  FLEX_SITE_MANAGEMENT: 'e3e8edb6-f4e2-4b89-a99f-80ec4e5c8ec5',
  FLEX_PAYOUT_MANAGEMENT: '4359d52a-d67c-409f-9e24-0e2671f54fc1', //todo
  FLEX_SITE_MANAGEMENT_DETAILS: '3f42097f-b6e5-44c2-9d37-15a8078ed202',
  GRIEVANCE_MANAGEMENT: '2bc97300-980f-4105-9926-2e07405097be',
  GRIEVANCE_DETAIL: '2bc97300-980f-4105-9926-2e07405097be', //TODO ONCE BACKEND CHANGE
  TRANSFER_MODULE: 'c095f058-d8c5-4489-a8a3-10c25f421d7d',
  TRANSFER_REQUESTS_TRACKER: 'b8e9a1dd-4198-44ca-aaf9-3ed16eff9b92',
  TRANSFER_REQUESTS_TRACKER_DETAILS: 'fc25ed56-f0ef-402f-a333-e6fb96191268',
  TRANSFER_EMPLOYEE_HISTORY: 'b4c6a95b-192a-499b-89c1-9abc65b6dc65',
  APPROVAL_TRANSFERS: '53b437a9-d268-4a86-bab1-9094d2b16ce3',
  APPROVAL_TRANSFERS_OPEN_REQUESTS: '53b437a9-d268-4a86-bab1-9094d2b16ce3',
  APPROVAL_TRANSFERS_CLOSED_REQUESTS: '53b437a9-d268-4a86-bab1-9094d2b16ce3',
  PROFILE: 'PUBLIC_MODULE_ID',
  VENDOR_ONBOARDING: 'PUBLIC_MODULE_ID',
  VENDOR_SALARY_PAYOUT: '2ed5e55c-c42e-4bcc-8de4-4f9bf95692f6',
  SALARY_MAPPING: '0b53902e-0b4b-4b93-b54a-8e67e43d912a',
  PAYOUT_PROCESSING: 'f04c705d-c6e9-404e-b45f-47b3843adde8',
  VENDOR_PROCESSED_PAYOUT_VIEW: '6a190481-3dcf-4048-801e-49b559cfdead',
  EDGE_PAYOUT_PROCESSING: 'c08d61b8-13eb-477a-ab5f-1cb70a3c51b4',
  CREATE_BULK_USER_CREATION: '6ed62848-5fa4-4b96-a19c-68daecbb74e8',
  CREATE_BULK_USER_UPDATION: '6e01a801-597c-4b15-a5a7-4ab87c926937',
  BLACKLISTED_EMPLOYEE: 'da4d2e19-a40d-4b12-8f4f-d6aa0bdcf6a3',
  ROASTER_PLANNING: 'aa285e96-918a-4c3c-acc8-cf87d21686cd',
  APPROVAL_ABSCONDING: '95a59d40-b602-42c1-b3fb-9d22f3e56ad3',
  BLACKLISTING_SEPERATION: '7fc57190-f2d3-4022-b6b9-d3a86e887083',

  CREATE_INCENTIVE: 'a31315c4-4096-4da1-b1f3-c58a0be8bbde',
  INCENTIVE_VIEW: 'a31315c4-4096-4da1-b1f3-c58a0be8bbde',
  INCENTIVE_MANAGEMENT: 'a31315c4-4096-4da1-b1f3-c58a0be8bbde',

  REFERRAL_RATE_CARD_MANAGEMENT: '611919b3-f550-4cc5-9dae-6573e87f4595',

  ADDENDUM_MANAGEMENT: 'ea83bf19-0a4a-4acc-a5e5-f880be4cc547',

  FT_FLEX_MANAGEMENT: '620fcb82-3504-4e69-a6ca-0ba42f569b41',
  FT_FLEX_SLOT_MANAGEMENT: 'bab6cf2b-df61-4737-a5cf-e2e280186a22',
  FT_FLEX_RATE_CARD_MANAGEMENT: 'af3d6d42-da26-4a52-a74b-c269696d6ae9',

  IT_APPROVALS: 'cafdda15-73d4-45c5-a94d-729b167e6881',
  IT_APPROVALS_SEPARATION: 'cafdda15-73d4-45c5-a94d-729b167e6881',
  IT_APPROVALS_EMPLOYEE_ASSET: 'a336a896-1232-477b-808d-e1d6d20a11e2',
  IT_APPROVALS_EMPLOYEE_ASSET_OPEN_REQUESTS:
    'a336a896-1232-477b-808d-e1d6d20a11e2',
  IT_APPROVALS_EMPLOYEE_ASSET_CLOSED_REQUESTS:
    'a336a896-1232-477b-808d-e1d6d20a11e2',
  APPROVAL_IT_REVIEW: 'cafdda15-73d4-45c5-a94d-729b167e6881',
  APPROVAL_IT_REVIEW_OPEN_REQUESTS: 'cafdda15-73d4-45c5-a94d-729b167e6881',
  APPROVAL_IT_REVIEW_CLOSED_REQUESTS: 'cafdda15-73d4-45c5-a94d-729b167e6881',
  APPROVAL_POST_ONBOARDING: '1cb850d7-7481-4d06-9970-19482be0ac5f',
};
